/* eslint-disable */
export const colorUtil = {
  getThemedColor: (dark) => {
    if (dark) {
      return '#FFFFFF';
    }
    return '#5D5463';
  },
};
